import React, { CSSProperties, FC } from 'react'
import cn from 'classnames'

import { ReactComponent as CheckboxArrow } from 'sources/images/checkboxArrow.svg'

import styles from './styles.module.scss'

interface IProps {
  active: boolean
  id?: number | string
  onClick: (value?: number | string) => void
  style?: CSSProperties
}

//Resize
export const CheckBox: FC<IProps> = ({ active, id, onClick, style }) => {
  const handlerClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    onClick(id)
  }
  return (
    <div onClick={(e) => handlerClick(e)} style={style}>
      <div className={cn({
        [styles.checkbox]: true,
        [styles.checkboxActive]: active,
      })}>
        {active ? <CheckboxArrow /> : null}
      </div>
    </div>
  )
}
